import Assert from "tbAssert";

import ngAria from "angular-aria";
import ngSanitize from "angular-sanitize";

import TbAuthServiceModule from "tbClient/services/auth";

const mAuthSvc = new WeakMap();
const mLogSvc = new WeakMap();

class TbSignInController {
    constructor($log, TbAuthService) {
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        Assert.StrictAssert(TbAuthService != null, "Assertion Failure: Missing Auth0 Service Dependency");

        mLogSvc.set(this, $log);
        mAuthSvc.set(this, TbAuthService);
    }

    get _authSvc() {
        return mAuthSvc.get(this);
    }

    get isSignedIn() {
        return this._authSvc.isAuthenticated();
    }

    login() {
        this._authSvc.login();
    }
}

TbSignInController.$inject = [
    "$log",
    "TbAuthService"
];

TbSignInController.template = require("./TbSignIn.tpl.html");
TbSignInController.controllerAs = "tbSignInCtrl";

TbSignInController.dependencies = [
    ngAria,
    ngSanitize,
    TbAuthServiceModule
];

export default TbSignInController;



//////////////////
// WEBPACK FOOTER
// ./src/directives/user-auth/TbSignInController.js
// module id = E/Kn
// module chunks = 1